// extracted by mini-css-extract-plugin
module.exports = {"subtitleToggle":"styles_subtitleToggle__JSbaL","small":"styles_small__v5-9k","enabled":"styles_enabled__1yPtL"};